import React from 'react';
import * as toolSelectors from '../../../../../selectors/tools';
import { useSelector } from 'react-redux';
import { isOfferAppliedToSelectedRbiOrder } from '../../../../../util';
import {
  ResultsColumn,
  ResultsColumnHeader,
  Row,
  HeaderRow,
  RefundAmountsList,
  OrderedItemsList,
  SubTitleText,
  Spreadsheet,
} from '../../DTInfoWidget.styles';
import isEmpty from 'lodash/isEmpty';

const DTRbiRefundInfoWidget = () => {
  const {
    customerName,
    refundAmountsList,
    selectedItems,
    storeAddress,
    deliveryStatus,
    couponType,
    pointsAmount,
    paymentCardType,
  } = useSelector(toolSelectors.getRbiRefundInfoWidgetData);

  const selectedOrder = useSelector(toolSelectors.getSelectedOrder);
  const isOfferApplied = isOfferAppliedToSelectedRbiOrder(selectedOrder.cart);

  return (
    <>
      {isOfferApplied && (
        <SubTitleText style={{ marginTop: '15px' }}>
          The total price of the selected items is greater than the total paid price because an offer has been applied
          to the order. A full refund will be processed.
        </SubTitleText>
      )}
      <Spreadsheet className="fs-block">
        <HeaderRow>
          <ResultsColumnHeader>CUSTOMER NAME</ResultsColumnHeader>
          <ResultsColumnHeader>STORE ADDRESS</ResultsColumnHeader>
          <ResultsColumnHeader>DELIVERY STATUS</ResultsColumnHeader>
          <ResultsColumnHeader>PAYMENT</ResultsColumnHeader>
        </HeaderRow>
        <Row>
          <ResultsColumn>{customerName}</ResultsColumn>
          <ResultsColumn>{storeAddress}</ResultsColumn>
          <ResultsColumn>{deliveryStatus}</ResultsColumn>
          <ResultsColumn>{paymentCardType}</ResultsColumn>
        </Row>
      </Spreadsheet>
      <Spreadsheet className="fs-block">
        <HeaderRow>
          <ResultsColumnHeader>ITEMS</ResultsColumnHeader>
          {!!Array.isArray(refundAmountsList) && <ResultsColumnHeader>REFUND AMOUNT</ResultsColumnHeader>}
          {!!couponType && <ResultsColumnHeader>COUPON TYPE</ResultsColumnHeader>}
          {!!pointsAmount && <ResultsColumnHeader>POINTS AMOUNT</ResultsColumnHeader>}
        </HeaderRow>
        <Row>
          <ResultsColumn>
            <OrderedItemsList>
              {isEmpty(selectedItems) ? (
                <li>Full Order</li>
              ) : (
                selectedItems.map((item) => (
                  <li key={item.name}>
                    {item.name} - {item.price} {!!item.points && `- ${item.points} Loyalty Points`}
                  </li>
                ))
              )}
            </OrderedItemsList>
          </ResultsColumn>
          {!!Array.isArray(refundAmountsList) && (
            <RefundAmountsList>
              {refundAmountsList.map((amount) => {
                if (amount.value) {
                  return (
                    <li key={amount.name}>
                      {amount.name}: {amount.value}
                    </li>
                  );
                }

                return null;
              })}
            </RefundAmountsList>
          )}
          {!!couponType && <ResultsColumn>{couponType}</ResultsColumn>}
          {!!pointsAmount && <ResultsColumn>{pointsAmount}</ResultsColumn>}
        </Row>
      </Spreadsheet>
    </>
  );
};
export default DTRbiRefundInfoWidget;
